import { React, useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import arrow from '../../assets/nextPage.png'
import colors from '../../styles/colors'

const StyledUserImpact = styled.div`
    display: flex;
    justify-content: space-between;
    width: 280px;
    height: 120px;
    border-radius: 2vh;
    background-color: ${colors.second};
    color: white;
    padding: 15px;
    display: flex;
    font-size: 100%;
    box-shadow: 0 0 30px grey;
`

const StyledPreviousImpact = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    img {
        padding: 3px;
        height: 20px;
        object-fit: scale-down;
        &:hover {
            cursor: pointer;
        }
    }
`
const StyledNextImpact = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    img {
        padding: 3px;
        height: 20px;
        object-fit: scale-down;
        transform: rotate(180deg);
        &:hover {
            cursor: pointer;
        }
    }
`
const StyledValues = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
`
const slideLeft = keyframes`
    0% {
        transform: translateX(0);
        opacity: 1;
    }
    49.9% {
        transform: translateX(-50%);
        opacity: 0;
    }
    50.1% {
        transform: translateX(50%);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
`
const slideRight = keyframes`
    0% {
        transform: translateX(0);
        opacity: 1;
    }
    49.9% {
        transform: translateX(50%);
        opacity: 0;
    }
    50.1% {
        transform: translateX(-50%);
        opacity: 0;
    }
    100% {
        transform: translateX(0);
        opacity: 1;
    }
`
const StyledImpactSlides = styled.div`
    &.isAnimatedLeft {
        animation: ${slideLeft} 2s ease-in-out;
    }
    &.isAnimatedRight {
        animation: ${slideRight} 2s ease-in-out;
    }
`

function EquivalentImpact({ userInfo, isSwapping }) {
    const [isMoneyImpactAnimated, setIsMoneyImpactAnimated] = useState(false)
    const [isCO2ImpactAnimated, setIsCO2ImpactAnimated] = useState(false)
    const [isTrashImpactAnimated, setIsTrashImpactAnimated] = useState(false)

    const nbApples = ((userInfo?.impactMoney || 0) / 0.5).toFixed(0) // prix moyen d'une pomme en Suisse
    const nbEggs = ((userInfo?.impactMoney || 0) / 0.5).toFixed(0) // prix moyen d'un oeuf en Suisse
    const kgPasta = ((userInfo?.impactMoney || 0) / 4).toFixed(3) // prix moyen d'un kg de pâte en Suisse
    const moneyImpactList = [
        <span>{nbApples} pommes 🍏</span>,
        <span>{nbEggs} oeufs 🐔</span>,
        <span>{kgPasta * 1000} g de pâtes 🍝</span>,
    ]

    const kmCar = ((userInfo?.impactCO2 || 0) / 0.15).toFixed(0)
    const hBulb = ((userInfo?.impactCO2 || 0) / 0.02).toFixed(0)
    const hHeater = ((userInfo?.impactCO2 || 0) / 0.1).toFixed(0)
    const CO2ImpactList = [
        <span>{kmCar} km en voiture 🚗</span>,
        <span>Ampoule allumée {hBulb} h 💡</span>,
        <span>{hHeater} h de chauffage 🔥</span>,
    ]

    const nbYogurts = ((userInfo?.impactTrash || 0) / 0.04).toFixed(0)
    const nbPlasticBags = ((userInfo?.impactCO2 || 0) / 0.01).toFixed(0)
    const nbPizzaCardboard = ((userInfo?.impactCO2 || 0) / 0.15).toFixed(0)
    const trashImpactList = [
        <span>{nbYogurts} pots de yahourt 🥄</span>,
        <span>{nbPlasticBags} sacs plastiques 🛍️</span>,
        <span>{nbPizzaCardboard} cartons de pizza 🍕</span>,
    ]

    const [swapItem, setSwapItem] = useState(0.5)
    const [currentMoneyImpact, setCurrentMoneyImpact] = useState(0)
    const [currentCO2Impact, setCurrentCO2Impact] = useState(0)
    const [currentTrashImpact, setCurrentTrashImpact] = useState(0)

    const swapMoneyImpact = function (i) {
        setIsMoneyImpactAnimated(i) // Démarre l'animation
        setTimeout(() => {
            setCurrentMoneyImpact(
                (prev) =>
                    (((prev + i) % moneyImpactList.length) +
                        moneyImpactList.length) %
                    moneyImpactList.length
            ) // Change l'impact
            setTimeout(() => {
                setIsMoneyImpactAnimated(false) // Arrête l'animation après 1.5 secondes
            }, 1000) // Attente de 1.5 secondes avant d'arrêter l'animation
        }, 1000) // Attente de 1.5 secondes avant de changer l'impact
    }
    const swapCO2Impact = function (i) {
        setIsCO2ImpactAnimated(i) // Cela démarre l'animation après un délai
        setTimeout(() => {
            setCurrentCO2Impact(
                (prev) =>
                    (((prev + i) % CO2ImpactList.length) +
                        CO2ImpactList.length) %
                    CO2ImpactList.length
            ) // Change l'impact
            setTimeout(() => {
                setIsCO2ImpactAnimated(false) // Arrête l'animation après 1.5 secondes
            }, 1000) // Attente de 1.5 secondes avant d'arrêter l'animation
        }, 1000) // Attente de 1.5 secondes avant de changer l'impact
    }
    const swapTrashImpact = function (i) {
        setIsTrashImpactAnimated(i) // Cela démarre l'animation après un délai
        setTimeout(() => {
            setCurrentTrashImpact(
                (prev) =>
                    (((prev + i) % trashImpactList.length) +
                        trashImpactList.length) %
                    trashImpactList.length
            ) // Change l'impact
            setTimeout(() => {
                setIsTrashImpactAnimated(false) // Arrête l'animation après 1.5 secondes
            }, 1000) // Attente de 1.5 secondes avant d'arrêter l'animation
        }, 1000) // Attente de 1.5 secondes avant de changer l'impact
    }

    useEffect(() => {
        setSwapItem((prev) => prev + 0.5)
        if (swapItem % 1) {
            let impactToSwap = Math.floor(Math.random() * 3)
            if (impactToSwap === 0) {
                swapMoneyImpact(1)
            } else if (impactToSwap === 1) {
                swapCO2Impact(1)
            } else if (impactToSwap === 2) {
                swapTrashImpact(1)
            }
        }
    }, [isSwapping])

    const handleClick = (e) => {
        const itemName = e.target.className
        if (itemName === 'previousMoneyImpact') {
            swapMoneyImpact(-1)
        } else if (itemName === 'nextMoneyImpact') {
            swapMoneyImpact(+1)
        } else if (itemName === 'previousCO2Impact') {
            swapCO2Impact(-1)
        } else if (itemName === 'nextCO2Impact') {
            swapCO2Impact(+1)
        } else if (itemName === 'previousTrashImpact') {
            swapTrashImpact(-1)
        } else if (itemName === 'nextTrashImpact') {
            swapTrashImpact(+1)
        }
    }

    return (
        <StyledUserImpact>
            <StyledPreviousImpact>
                <img
                    src={arrow}
                    alt="money"
                    className="previousMoneyImpact"
                    onClick={(e) => handleClick(e)}
                />
                <img
                    src={arrow}
                    alt="CO2"
                    className="previousCO2Impact"
                    onClick={(e) => handleClick(e)}
                />
                <img
                    src={arrow}
                    alt="trash"
                    className="previousTrashImpact"
                    onClick={(e) => handleClick(e)}
                />
            </StyledPreviousImpact>
            <StyledValues>
                <StyledImpactSlides
                    className={
                        isMoneyImpactAnimated === -1
                            ? 'isAnimatedLeft'
                            : isMoneyImpactAnimated === 1
                            ? 'isAnimatedRight'
                            : ''
                    }
                >
                    {moneyImpactList[currentMoneyImpact]}
                </StyledImpactSlides>
                <StyledImpactSlides
                    className={
                        isCO2ImpactAnimated === -1
                            ? 'isAnimatedLeft'
                            : isCO2ImpactAnimated === 1
                            ? 'isAnimatedRight'
                            : ''
                    }
                >
                    {CO2ImpactList[currentCO2Impact]}
                </StyledImpactSlides>
                <StyledImpactSlides
                    className={
                        isTrashImpactAnimated === -1
                            ? 'isAnimatedLeft'
                            : isTrashImpactAnimated === 1
                            ? 'isAnimatedRight'
                            : ''
                    }
                >
                    {trashImpactList[currentTrashImpact]}
                </StyledImpactSlides>
            </StyledValues>
            <StyledNextImpact>
                <img
                    src={arrow}
                    alt="money"
                    className="nextMoneyImpact"
                    onClick={(e) => handleClick(e)}
                />
                <img
                    src={arrow}
                    alt="CO2"
                    className="nextCO2Impact"
                    onClick={(e) => handleClick(e)}
                />
                <img
                    src={arrow}
                    alt="trash"
                    className="nextTrashImpact"
                    onClick={(e) => handleClick(e)}
                />
            </StyledNextImpact>
        </StyledUserImpact>
    )
}

export default EquivalentImpact
